import RoomSecurity from '../../Room/View/Security';

const useVisitorEmail = (roomUuid: string): string | undefined => {
  const accessData = RoomSecurity.getAccess(roomUuid);
  return accessData?.email;
};

export default useVisitorEmail;
